<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="850px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <basic-data-form
        ref="basicData"
        :shop="shop"
      />
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import BasicDataForm from './forms/BasicData';
  import PricesForm from './forms/Prices';


  export default {
    components: {
      BasicDataForm,
      PricesForm,
    },
    props: ['type', 'shopId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        selectedTab: 'Alapadatok',

        shop: {
          name: '',
          email: '',
          phone: '',
          is_active: true,
          representative_users: [],
          partner_id: null,
          location_id: null,
          shop_category_id: null,
          shop_chain_id: null,
          address: {
            postal_code: null,
            city: '',
            street: '',
            street_no: '',
            floor: '',
            door_no: '',
            street_suffix: '',
            country_id: null,
            county_id: null,
          },
          product_prices: [],
          send_invoice_email: false,
        },
      };
    },
    computed: {

      title() {
        if (this.type === 'add') {
          return 'Új üzlet';
        } else if (this.type === 'update') {
          return 'Üzlet módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;

      if (this.shopId) {
        this.shop = await this.$store.dispatch('shop/fetch', this.shopId);
        this.shop.representative_users = this.shop.representative_users.map(u => u.id);
      }
      this.loading = false;
    },
    methods: {
      onPriceChange(prices) {
        this.shop.product_prices = prices;
      },
      onPriceAdd(price) {
        this.shop.product_prices.push(price);
      },
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/data/shops/shops');
        })
        .catch(() => {
        });
      },
      async store() {
        this.$refs['basicData'].$refs['basicDataForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('shop/create', this.shop);
              } else if (this.type === 'update') {
                await this.$store.dispatch('shop/update', this.shop);
              }
              this.$store.dispatch('shop/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/data/shops/shops');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
    },
  };
</script>
